import styled from 'styled-components';
import { CssSpace } from '@xbcb/ui-types';

export const StyledContainer = styled.div`
  margin-top: ${CssSpace.SPACE_4};
`;

export const StyledInlineDiv = styled.div`
  .ant-row {
    display: inline-block;
  }
  .form-inline {
    display: inline-block;
  }
`;
